import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appQueriesStore } from "@/app/api";
import { errorToast } from "@/shared/ui";
import { intakeFormQueriesStore, submitHealthieForm } from "../api";

export const useSubmitHealthieForm = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: submitHealthieForm,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: appQueriesStore.user.queryKey,
      });
      void queryClient.invalidateQueries({
        queryKey: intakeFormQueriesStore.healthie.form._def,
      });
    },
    onError: errorToast,
  });
};
